import type React from 'react';
import { useEffect } from 'react';

// Hook that alerts clicks outside of the passed ref
// https://stackoverflow.com/questions/32553158/detect-click-outside-react-componentS
export const useOutsideClickAlerter = (ref: React.RefObject<HTMLElement>, onOutsideClick: () => void): void => {
  useEffect(() => {
    const handleClickOutside = (event): void => {
      if (ref.current === null || ref.current === undefined) {
        return;
      }

      if (ref.current.contains(event.target)) {
        return;
      }

      onOutsideClick();
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};
